import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  LinearProgress,
  Stack,
} from "@mui/material";
import VerifiedIcon from "../../../Activos/Imagenes/EmailVerification/a.svg";

const DialogoVerificacionIdentificacion = ({
  open = false,
  isVerifying,
  identificationProvider,
  identificationNumber,
  onConfirm,
  onClose,
  etiquetas,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      disableEscapeKeyDown
      onClose={(_, reason) => {
        // Prevenir cierre por click en backdrop o ESC
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          padding: "60px",
          width: 328,
          position: "relative",
          overflow: "hidden",
        },
      }}
    >
      {/* Estado de carga en verificación - Posicionado en el borde superior */}
      {isVerifying && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1,
          }}
        >
          <Stack sx={{ width: "100%", color: "#223354" }} spacing={2}>
            <LinearProgress color="inherit" />
          </Stack>
        </Box>
      )}

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 0,
          gap: "30px",
        }}
      >
        {/* Icono de escudo */}
        <img
          src={VerifiedIcon}
          alt="Verified"
          style={{ width: 86, height: 98 }}
        />

        {/* Título */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 500,
            color: "#223354",
            fontSize: "24px",
            fontFamily: "'Roboto', sans-serif",
          }}
        >
          {etiquetas?.General?.Et_IdentityVerification ||
            "Verificación de identidad"}
        </Typography>

        {/* Texto descriptivo */}
        <Typography
          variant="body2"
          sx={{
            color: "#3F425D",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "18px",
            fontFamily: "'Roboto', sans-serif",
            textAlign: "center",
          }}
        >
          {etiquetas?.General?.Et_IdentityVerificationDescription?.replace(
            "{0}",
            identificationProvider,
          ) ||
            "¿Desea validar su identificación con el proveedor de verificación de identidad {0}?".replace(
              "{0}",
              identificationProvider,
            )}
        </Typography>

        <strong style={{ color: "#1F2937" }}>{identificationNumber}</strong>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          paddingInline: "24px",
          paddingTop: "50px",
          gap: "10px",
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={isVerifying}
          sx={{
            width: "45%",
            maxWidth: "300px",
            backgroundColor: "#a8abb6",
            color: "#FFFFFF",
            fontWeight: 600,
            fontSize: "18px",
            textTransform: "none",
            borderRadius: "5px",
            padding: "6px",
            border: 0,
            "&:hover": {
              backgroundColor: "#939bb8",
              border: 0,
            },
            "&.Mui-disabled": {
              backgroundColor: "#868994",
              color: "#b8bbc0",
            },
          }}
        >
          {etiquetas?.General?.Et_tbnCancelar || "Cancelar"}
        </Button>

        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={isVerifying}
          sx={{
            width: "45%",
            maxWidth: "300px",
            backgroundColor: "#082478",
            color: "#FFFFFF",
            fontWeight: 600,
            fontSize: "18px",
            textTransform: "none",
            borderRadius: "5px",
            padding: "6px",
            border: 0,
            "&:hover": {
              backgroundColor: "#082478",
              border: 0,
            },
            "&.Mui-disabled": {
              backgroundColor: "#1f3474",
              color: "#9CA3AF",
            },
          }}
        >
          {etiquetas?.General?.Et_tbnConfirmar || "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogoVerificacionIdentificacion;
